<template>
    <div class="esp">
        <mdb-badge pill :color="item.color">{{ item.title }}</mdb-badge>
    </div>
</template>

<script>
    import { mdbBadge } from 'mdbvue';
    export default {
        name: "ListRef",
        components: {
            mdbBadge
        },
        props:{
            item:{type: Object}
        }
    }
</script>

<style lang="scss" scoped>
    .esp {
        margin-left: 10px;
    }
</style>